import { ArrowUpRight, MapPin, Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { EMAIL, ADDRESS, MAP_URL } from "../../content";

export const Contact = ({ t }) => (
  <section id="contact" data-testid="contact-section" className="bg-[var(--ivory)] py-24 text-[var(--ink)] lg:py-36">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <Reveal><p className="label">{t.contact.label}</p></Reveal>
      <div className="mt-10 grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal delay={0.05}>
            <h2 className="font-display text-6xl font-light italic tracking-tight sm:text-7xl lg:text-8xl">{t.contact.title}</h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-8 max-w-md text-base leading-relaxed text-[var(--muted)] md:text-lg">{t.contact.body}</p>
          </Reveal>
        </div>
        <div className="space-y-6 lg:col-span-7">
          <Reveal delay={0.1}>
            <a href={`mailto:${EMAIL}`} data-testid="contact-email-link" className="contact-card group">
              <Mail className="h-5 w-5 text-[var(--gold-deep)]" />
              <div className="min-w-0 flex-1">
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[var(--muted)]">{t.contact.emailLabel}</p>
                <p className="mt-2 break-all font-display text-2xl sm:text-3xl lg:text-4xl">{EMAIL}</p>
              </div>
              <ArrowUpRight className="h-6 w-6 shrink-0 transition-transform duration-500 group-hover:rotate-45" />
            </a>
          </Reveal>
          <Reveal delay={0.18}>
            <a href={MAP_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-address-link" className="contact-card group">
              <MapPin className="h-5 w-5 text-[var(--gold-deep)]" />
              <div className="min-w-0 flex-1">
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[var(--muted)]">{t.contact.addressLabel}</p>
                <address data-testid="contact-address" className="mt-2 font-display text-xl not-italic leading-snug sm:text-2xl">
                  {ADDRESS.line1}<br />{ADDRESS.line2}<br />{ADDRESS.city}
                </address>
                <span className="mt-4 inline-block font-mono text-[11px] uppercase tracking-[0.25em] text-[var(--gold-deep)]">{t.contact.map}</span>
              </div>
              <ArrowUpRight className="h-6 w-6 shrink-0 transition-transform duration-500 group-hover:rotate-45" />
            </a>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
